var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{class:{ 'cell-edit':!this.disabled, 'text-white': this.bgColor},style:(_vm.styles)},[_c('vx-tooltip',{attrs:{"delay":_vm.tooltipDelay,"text":_vm.tooltipText,"tooltipPosition":_vm.tooltipPosition}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }